import { t } from '../../i18n.es.js';
import React from 'react';
import { styled, Card, Col, Button, Row, LazyImage } from '@teko/ui';
import { Body } from '@teko/ds-foundation';
import { BuildPcNumberStepper } from '../BuildPcNumberStepper/BuildPcNumberStepper.es.js';
import { ProductPrice } from '../../Common/ProductPrice/ProductPrice.es.js';
import { ProductGifts } from '../../Common/ProductGifts/ProductGifts.es.js';
import { ProductName } from '../../Common/ProductName/ProductName.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Anchor = styled.a`
  color: unset;
  text-decoration: unset;
`;
const StyledCard = styled(Card)`
  padding: 1.5rem 1rem;
  transition: box-shadow 0.2s ease-in-out;
  &:hover {
    box-shadow: 0.1rem 0.1rem 0.5rem 0.1rem rgba(0, 0, 0, 0.08);
  }
`;
const StyledCol = styled(Col)`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;
const StyledPrice = styled(ProductPrice)`
  min-height: auto;
`;
const Title = styled.div`
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  font-weight: 500;
`;
const NameWrapper = styled(Col)`
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  display: flex;
  align-items: center;
`;
const StyledProductGifts = styled(ProductGifts)`
  margin-top: 5px;
`;
const SKU = styled.span`
  color: #757575;
  font-size: 0.8125rem;
`;
const StyledButton = styled(Button)`
  height: 32px;
  width: 60px;
  padding: 0;
`;
const StyledButtonDelete = styled(Body)(({ theme }) => `
  margin-top: 12px;
  cursor: pointer;
  color: ${theme == null ? void 0 : theme.colors.link500};
  :hover {
    color: ${theme == null ? void 0 : theme.colors.error500};
  }
`);
const BuildPcItem = (_a) => {
  var _b = _a, {
    title,
    product,
    icon = "",
    onIncrease,
    onDecrease,
    onClick,
    actionText,
    quantity,
    setQuantity,
    showDeleteButton = false,
    onDelete
  } = _b, props = __objRest(_b, [
    "title",
    "product",
    "icon",
    "onIncrease",
    "onDecrease",
    "onClick",
    "actionText",
    "quantity",
    "setQuantity",
    "showDeleteButton",
    "onDelete"
  ]);
  var _a2, _b2;
  const disableButton = () => {
    var _a3;
    if (product && !((_a3 = product == null ? void 0 : product.price) == null ? void 0 : _a3.latestPrice))
      return true;
  };
  return /* @__PURE__ */ React.createElement(StyledCard, __spreadValues({}, props), /* @__PURE__ */ React.createElement(Row, null, title && /* @__PURE__ */ React.createElement(StyledCol, {
    col: 1.5
  }, /* @__PURE__ */ React.createElement(Title, null, title)), /* @__PURE__ */ React.createElement(StyledCol, {
    col: 1.5
  }, /* @__PURE__ */ React.createElement(LazyImage, {
    imageWidth: 150,
    src: (product == null ? void 0 : product.imageUrl) || icon,
    onClick: () => {
      if (!product)
        onClick == null ? void 0 : onClick();
    },
    border: true,
    borderRadius: 8,
    contain: true
  })), /* @__PURE__ */ React.createElement(NameWrapper, null, product ? /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(Anchor, {
    href: (_b2 = (_a2 = product.link) == null ? void 0 : _a2.as) == null ? void 0 : _b2.pathname,
    rel: "noreferrer noopener",
    target: "_blank"
  }, /* @__PURE__ */ React.createElement(ProductName, {
    name: product.name || t("T\xEAn s\u1EA3n ph\u1EA9m \u0111ang \u0111\u01B0\u1EE3c c\u1EADp nh\u1EADt")
  })), /* @__PURE__ */ React.createElement(SKU, null, "SKU: ", product.sku), product.gifts && /* @__PURE__ */ React.createElement(StyledProductGifts, {
    label: t("T\u1EB7ng ngay"),
    images: product.gifts.images
  })) : /* @__PURE__ */ React.createElement("div", null, t("Vui l\xF2ng ch\u1ECDn linh ki\u1EC7n"))), quantity && /* @__PURE__ */ React.createElement(StyledCol, {
    col: 2
  }, /* @__PURE__ */ React.createElement(BuildPcNumberStepper, {
    onIncrease,
    onDecrease,
    setValue: setQuantity,
    value: quantity
  }), showDeleteButton && /* @__PURE__ */ React.createElement(StyledButtonDelete, {
    level: 1,
    onClick: onDelete
  }, t("X\xF3a"))), product && product.price && /* @__PURE__ */ React.createElement(StyledCol, {
    col: 2
  }, /* @__PURE__ */ React.createElement(StyledPrice, __spreadValues({}, {
    price: product.price.latestPrice,
    discount: product.price.discountPercent,
    listedPrice: product.price.supplierRetailPrice
  }))), /* @__PURE__ */ React.createElement(StyledCol, {
    col: 1.5
  }, product && product.showContact ? /* @__PURE__ */ React.createElement(StyledButton, {
    block: true,
    variant: "primary",
    tag: "a",
    href: "https://m.me/phongvuvietnam",
    marginBottom: 2,
    target: "_blank"
  }, t("Li\xEAn h\u1EC7")) : /* @__PURE__ */ React.createElement(StyledButton, {
    disabled: disableButton(),
    onClick,
    variant: "primary"
  }, actionText))));
};

export { BuildPcItem };
